module.exports = __webpack_public_path__ + "img/40_38_065_040.983fdb30.jpg";